// extracted by mini-css-extract-plugin
export default {"search-container":"dropboxer_search_search-container__fuI9a"};